import { ERatingActionTypes } from '../../actions/rating/types';
import { ERatingStatus, IRatingState } from '../../types/rating';
import { TReduxActions } from '../../types/redux';

export const defaultState: IRatingState = {
  rating: null,
  status: ERatingStatus.Initial,
};

export const ratingReducer = (state: IRatingState = defaultState, action: TReduxActions) => {
  switch (action.type) {
    case ERatingActionTypes.Succeed:
      return { ...state, rating: action.payload, status: ERatingStatus.Succeed };
    case ERatingActionTypes.Loading:
      return { ...state, status: ERatingStatus.Loading };
    case ERatingActionTypes.Failed:
      return { ...state, rating: null, status: ERatingStatus.Failed };
    default:
      return state;
  }
};
